var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',[_c('DatePicker',{attrs:{"type":"year"},on:{"on-change":_vm.getData},model:{value:(_vm.year),callback:function ($$v) {_vm.year=$$v},expression:"year"}}),_c('Table',{attrs:{"loading":_vm.loading,"columns":_vm.columns,"no-data-text":_vm.L('NoDatas'),"border":"","data":_vm.data}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a7cb748","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/report/dialysisQuality/index.vue
// module id = null
// module chunks = 